import {
  CUSTOMER_SUPPORT_REQUEST_FAIL,
  CUSTOMER_SUPPORT_REQUEST_SUCCESS,
} from "../actionTypes";

const initialState = {
  data: null,
};

const customerSupportReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_SUPPORT_REQUEST_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
      };
    case CUSTOMER_SUPPORT_REQUEST_FAIL:
      return {
        ...state,
        data: null,
      };
    default:
      break;
  }
  return state;
};

export default customerSupportReducer;
